// extracted by mini-css-extract-plugin
export default {"nftContainer":"styles_nftContainer__gL7jh","video":"styles_video__Nwuvs"};